
import { useEffect, useState } from "react";
import {
  FaArrowRight,
  FaEnvelope,
  FaCode,
  FaReact,
  FaNode,
  FaJsSquare,
} from "react-icons/fa";
import tahirJamalImage from "../images/pic_2.jpeg";

export default function Header() {
  const [typedText, setTypedText] = useState("");
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const phrases = [
    "Software Engineer | React Developer | Full Stack Developer",
    "I build scalable web applications and elegant user experiences.",
  ];

  useEffect(() => {
    const current = phrases[phraseIndex];
    if (charIndex < current.length) {
      const id = setTimeout(() => {
        setTypedText(current.slice(0, charIndex + 1));
        setCharIndex((c) => c + 1);
      }, 40);
      return () => clearTimeout(id);
    }

    const resetId = setTimeout(() => {
      setCharIndex(0);
      setTypedText("");
      setPhraseIndex((idx) => (idx + 1) % phrases.length);
    }, 2200);

    return () => clearTimeout(resetId);
  }, [charIndex, phraseIndex]);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <header className="section" id="top">
      <div className="hero">
        <div className="hero-left">
          <div
            className="nav-pill"
            aria-label="Section navigation"
          >
            <div className="nav-dot" />
            <div className="nav-links">
              <button className="nav-link" type="button" onClick={() => scrollToSection("about")}>
                About
              </button>
              <button className="nav-link" type="button" onClick={() => scrollToSection("skills")}>
                Skills
              </button>
              <button
                className="nav-link"
                type="button"
                onClick={() => scrollToSection("experience")}
              >
                Experience
              </button>
              <button
                className="nav-link"
                type="button"
                onClick={() => scrollToSection("projects")}
              >
                Projects
              </button>
              <button
                className="nav-link"
                type="button"
                onClick={() => scrollToSection("contact")}
              >
                Contact
              </button>
            </div>
          </div>

          <div className="hero-eyebrow">
            <span className="hero-eyebrow-dot" />
            <span className="hero-eyebrow-text">Available for full-time & freelance work</span>
          </div>

          <h1 className="hero-name">
            Hi, I'm <span>Tahir Jamal</span>
          </h1>
          <p className="hero-title">
            <span>{typedText}</span>
            <span style={{ opacity: 0.65 }}>|</span>
          </p>

          <div className="hero-title-roles">
            <span className="hero-pill">Software Engineer</span>
            <span className="hero-pill">React Developer</span>
            <span className="hero-pill">Full Stack Developer</span>
          </div>

          <p className="hero-tagline">
            I build scalable web applications and elegant user experiences — from complex health
            insurance automation systems to intuitive dashboards and portals.
          </p>

          <div className="hero-cta-row">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => scrollToSection("projects")}
            >
              <span>View Projects</span>
              <span className="btn-icon">
                <FaArrowRight size={14} />
              </span>
            </button>
            <button
              type="button"
              className="btn btn-ghost"
              onClick={() => scrollToSection("contact")}
            >
              <span>Contact Me</span>
              <span className="btn-icon">
                <FaEnvelope size={14} />
              </span>
            </button>
          </div>

          <div className="hero-meta" aria-label="Key highlights">
            <div className="hero-meta-item">
              <span className="hero-dot-accent" />
              <span>4+ years building production-grade web applications</span>
            </div>
            <div className="hero-meta-item">
              <span className="hero-dot-accent" />
              <span>150+ responsive health-sector screens shipped</span>
            </div>
          </div>
        </div>

        <div className="hero-right" aria-hidden="true">
          <div className="hero-blob">
            <div className="hero-orbit">
              <div className="hero-orbit-dot" />
            </div>
            <div className="hero-blob-inner">
              <div>
                <div style={{ marginBottom: 10, display: "inline-flex", alignItems: "center" }}>
                  {/* <FaCode style={{ marginRight: 8 }} />
                  <span>Developer Visualization</span> */}
                </div>
                <img
                  src={tahirJamalImage}
                  alt="Portrait of Tahir Jamal"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "24px",
                  }}
                />
              </div>
            </div>
            <div className="hero-blob-tag">SDE - I</div>
            <div className="hero-floating-icons">
              <div className="hero-floating-icon">
                <FaReact />
              </div>
              <div className="hero-floating-icon">
                <FaJsSquare />
              </div>
              <div className="hero-floating-icon">
                <FaNode />
              </div>
              <div className="hero-floating-icon">
                <FaCode />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
